import React from "react";
import { Card, Icon, Row, Text, Column } from "@amzn/meridian";
import chevronRightSmallTokens from "@amzn/meridian-tokens/base/icon/chevron-right-small";
import { Question, Result } from "src/data/types";
import { getQuestionStatus } from "src/components/pages/inspection/utils";
import "./questionDisplayCard.scss";

type QuestionDisplayCardProps = {
  question: Question;
  questionOrder: number;
  onSelect?: (question: Question) => void;
  result?: Result;
};

const QuestionDisplayCard = ({
  question,
  questionOrder,
  onSelect,
  result,
}: QuestionDisplayCardProps) => {
  const status = result ? getQuestionStatus(question.questionId, [result] as any) : null;
  const isNA = status?.isNA === true;

  return (
    <div 
      style={{ cursor: isNA ? 'default' : (onSelect ? 'pointer' : 'default'), opacity: isNA ? 0.6 : 1 }}
      onClick={() => !isNA && onSelect && onSelect(question)}
    >
      <Card spacingInset="none">
        <Row alignmentHorizontal="justify" spacingInset="300 400" alignmentVertical="center">
          <Column spacing="100">
            <Text>{question.questionText}</Text>
            {status && status.answered && (
              <Row spacing="100" alignmentVertical="center">
                {status.isPending && (
                  <div style={{ 
                    width: "12px", 
                    height: "12px", 
                    border: "2px solid #f3f3f3",
                    borderTop: "2px solid #FF9900",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite"
                  }} />
                )}
                <Text type="b100">
                  <span style={{ 
                    color: isNA ? "#6c757d" : (status.isPending ? "#666" : (status.compliant ? "#0F7D40" : "#D13212"))
                  }}>
                    {status.displayText}
                  </span>
                </Text>
                {isNA && (
                  <Text type="b100">
                    <span style={{ color: "#6c757d", fontStyle: "italic" }}>
                      — Not applicable to this container
                    </span>
                  </Text>
                )}
              </Row>
            )}
          </Column>
          {!isNA && <Icon tokens={chevronRightSmallTokens} color="primary" />}
        </Row>
      </Card>
    </div>
  );
};

export default QuestionDisplayCard;
